import { render, staticRenderFns } from "./Mepolizumabe100Warning.vue?vue&type=template&id=2fe88b8c&"
import script from "./Mepolizumabe100Warning.vue?vue&type=script&lang=js&"
export * from "./Mepolizumabe100Warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports